import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlippingService } from '@nimbus-global/features/feature-flipping/feature-flipping.service';
import { Feature } from '@nimbus-global/features/feature-flipping/feature.enum';

@Injectable({ providedIn: 'root' })
export class CheckFeatureFlippingInFeatureManagementGuard implements CanActivate {
  public constructor(
    private readonly featureFlippingService: FeatureFlippingService,
    private readonly router: Router,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const features = route.data.features as Feature[] | undefined;
    const feature = route.data.feature as Feature;

    if (features?.length) {
      return combineLatest(features.map((f) => this.featureFlippingService.isEnabledInFeatureManagement(f))).pipe(
        map((results) => (results.some(Boolean) ? true : this.router.createUrlTree(['/']))),
      );
    }

    return this.featureFlippingService
      .isEnabledInFeatureManagement(feature)
      .pipe(map((isEnabled) => (isEnabled ? true : this.router.createUrlTree(['/']))));
  }
}
